import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=3f15e776&scoped=true&"
import script from "./Blacklist.vue?vue&type=script&lang=js&"
export * from "./Blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15e776",
  null
  
)

export default component.exports